import type { AppRuntimeConfig } from "./runtime-config-types";

export const getRuntimeConfig = (): Readonly<AppRuntimeConfig> => {
  const cfg = window.__APP_CONFIG__;
  if (!cfg) {
    throw new Error(
      "Runtime config not loaded. Ensure /config.js is included before the app bundle."
    );
  }
  return cfg;
};
